import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Review } from '../../../models/review';
import { ReplyTemplate } from '../reply-tab-group/template-selection/template-selection.component';
import { AiAssistedRepliesPerReview } from '../../../models/ai-assisted-replies-per-review';
import { AiSettings } from '../reply-tab-group/ai-replies-settings/ai-replies-settings.component';
import { AiRepliesLanguage } from './review.state';
import { ReviewTranslation } from '../../../models/review-translation';

export const reviewsAdapter: EntityAdapter<Review> = createEntityAdapter<Review>();
export const reviewTranslationsAdapter: EntityAdapter<ReviewTranslation> = createEntityAdapter<ReviewTranslation>();
export const replyTemplatesAdapter: EntityAdapter<ReplyTemplate> = createEntityAdapter<ReplyTemplate>({
  sortComparer: (temp1, temp2) => temp1.templateName.localeCompare(temp2.templateName),
});
export const aiSettingsAdapter: EntityAdapter<AiSettings> = createEntityAdapter<AiSettings>({
  sortComparer: false,
});
export const aiAssistedRepliesAdapter: EntityAdapter<AiAssistedRepliesPerReview> = createEntityAdapter<AiAssistedRepliesPerReview>();
export const aiDefaultLanguagesAdapter = createEntityAdapter<AiRepliesLanguage>({ selectId: (language) => language.key });
